import React from "react";
import "../../assets/css/style.css";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

function LoginHeader() {
  return (
    <div className="header">
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" className="navbar loginnavbar">
          <Toolbar className="header-container loginheader">
            {/* Platform Name */}
            <Typography className="navheading">
              EngageAll AMR WhatsApp Dashboard
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>
    </div>
  );
}

export default LoginHeader;
